<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_29769_248669)">
      <path d="M14 7.00034L12.4152 5.24073L12.6633 2.88504L10.3458 2.39444L9.16366 0.34082L7.00004 1.30781L6.70801 7.00034L7.00004 12.6929L9.16369 13.6598L10.3458 11.6063L12.6633 11.1156L12.4152 8.75993L14 7.00034Z" fill="#41A1E4"/>
      <path d="M4.83634 0.34082L3.65422 2.39444L1.33672 2.88506L1.58486 5.24073L0 7.00034L1.58486 8.75993L1.33672 11.1156L3.65422 11.6063L4.83637 13.6598L7.00001 12.6929V1.30781L4.83634 0.34082Z" fill="#41A1E4"/>
      <path d="M4.0835 6.41667L6.41683 8.75L9.91683 5.25" stroke="white" stroke-width="1.16667"/>
    </g>
    <defs>
      <clipPath id="clip0_29769_248669">
        <rect width="14" height="14" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>
<script setup/>
